<template>
  <div v-if="!dialogFormVisible" class="cangchuSy_pupop">
    <!-- v-if="dialogVisible" -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title=""
      :visible.sync="dialogVisible"
      width="1200px"
      @close="close"
    >
      <div
        style="
          width: 90%;
          margin-left: auto;
          margin-right: auto;
          max-width: 1200px;
          padding-top: 10px;
        "
      >
        <div>
          <el-form
            ref="form"
            label-position="right"
            :model="form"
            :rules="rules"
            label-width="120px"
          >
            <el-form-item label="报备类型:" prop="bblx">
              <el-select
                v-model="form.bblx"
                style="width: 100%"
                placeholder="增溢"
                :disabled="ccsytype || changeType || bgdisable"
                @change="bblxChange"
              >
                <el-option
                  v-for="item in options4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="委托单位:" prop="wtDwMc">
              <el-select
                v-model="form.wtDwMc"
                style="width: 100%"
                placeholder="请选择"
                :disabled="ccsytype || bgdisable"
                @change="wtdwChange"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="经办人:" prop="jbrName">
              <el-select
                v-model="form.jbrName"
                filterable
                style="width: 100%"
                placeholder="请选择"
                :disabled="ccsytype || bgdisable"
                @change="hchange"
              >
                <el-option
                  v-for="item in jbrList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="化学品:" prop="hxpBm">
              <el-cascader
                :key="keyValue"
                v-model="form.hxpBm"
                style="width: 100%"
                placeholder="请选择化学品"
                check-strictly
                :options="options3"
                :props="{ expandTrigger: 'hover' }"
                :disabled="ccsytype || changeType || bgdisable"
                @change="handleChange"
              />
            </el-form-item>

            <el-form-item label="存放仓库:" prop="ckId">
              <el-select
                v-model="form.ckId"
                style="width: 100%"
                placeholder="请选择"
                :disabled="ccsytype"
                @change="ckChange"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              :label="form.bblx != 34 ? '增溢数量:' : '损耗数量'"
              class="is-required"
            >
              <el-col :span="15">
                <el-form-item prop="sysl" style="width: 100%">
                  <el-input
                    v-model="form.sysl"
                    placeholder="请输入"
                    :disabled="ccsytype"
                  /> </el-form-item></el-col>
              <el-col :span="1">&nbsp;</el-col>
              <el-col :span="8">
                <el-form-item prop="syslDw" style="width: 100%">
                  <el-select
                    v-model="form.syslDw"
                    placeholder="单位"
                    :disabled="ccsytype"
                  >
                    <el-option
                      v-for="item in syslList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select> </el-form-item></el-col>
            </el-form-item>
            <el-form-item v-if="!ccsytype" label="当前库存:">
              <el-input
                v-model="form.dqkc"
                style="width: 65%"
                placeholder="请输入"
                disabled
              />
              <el-select
                v-model="form.dqkcDw"
                style="width: calc(35% - 10px); margin-left: 10px"
                placeholder="单位"
                disabled
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="报备日期:" prop="bbrq">
              <el-date-picker
                v-model="form.bbrq"
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                :disabled="ccsytype"
                :picker-options="pickerBeginDateBefore"
              />
            </el-form-item>

            <el-form-item label="登记人:">
              <el-input v-model="form.djr" disabled />
            </el-form-item>
            <el-form-item v-if="djsjshow" label="登记时间:" prop="djsj">
              <el-date-picker
                v-model="form.djsj"
                disabled
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item
              :label="form.bblx != 34 ? '增溢原因:' : '损耗原因'"
              style="width: 100%"
              prop="syyy"
            >
              <el-input
                v-model="form.syyy"
                type="textarea"
                :rows="3"
                resize="none"
                placeholder="请填写原因"
                :disabled="ccsytype || changeType || bgdisable"
              />
            </el-form-item>

            <el-form-item label="备注:" style="width: 100%">
              <el-input
                v-model="form.bz"
                placeholder="请填写原因"
                :disabled="ccsytype || changeType || bgdisable"
              />
            </el-form-item>
            <el-form-item
              v-if="biangengShow"
              label="变更理由:"
              style="width: 100%"
              prop="bgly"
            >
              <el-input v-model="form.bgly" placeholder="请填写原因" />
            </el-form-item>
            <!-- :auto-upload="false" -->
            <el-form-item label="证明材料:" required>
              <el-upload
                class="avatar-uploader"
                :headers="token"
                :action="returnSaveFile"
                :disabled="bgdisable"
                list-type="picture-card"
                :file-list="fileList"
                :before-upload="beforeUpload"
                :on-success="handleAvatarSuccess"
                :limit="1"
              >
                <i slot="default" class="el-icon-plus avatar-uploader-icon" />
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  >
                  <span class="el-upload-list__item-actions">
                    <span
                      v-preventReClick
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in" />
                    </span>
                    <span
                      v-if="leixing != 'change' && leixing != 'ck'"
                      v-preventReClick
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file)"
                    >
                      <i class="el-icon-download" />
                    </span>
                    <span
                      v-if="leixing != 'change' && leixing != 'ck'"
                      v-preventReClick
                      class="el-upload-list__item-delete"
                      @click="handleRemovePic(file)"
                    >
                      <i class="el-icon-delete" />
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :visible.sync="dialogVisible2"
                append-to-body
              >
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="">
        <bgcsOfDetail
          v-if="curRowObj.bgcs >= 1"
          :cur-row-obj="curRowObj"
          :cur-type="curType"
          :bgcs-t-k-name="'仓储损溢'"
          @bacsCkXqShow="bacsCkXqShow"
        />
      </div>
      <div class="buttonList">
        <el-button
          v-show="leixing == 'edit' || leixing == 'add'"
          v-preventReClick
          type="primary"
          @click="submitFormTemp"
        >暂时保存</el-button>

        <el-button
          v-if="form.bblx != 34"
          v-show="leixing == 'edit' || leixing == 'add'"
          v-preventReClick
          style=""
          type="primary"
          @click="submitForm('form', 'tj')"
        >入库</el-button>
        <el-button
          v-else
          v-show="leixing == 'edit' || leixing == 'add'"
          v-preventReClick
          style=""
          type="primary"
          @click="submitForm('form', 'tj')"
        >出库</el-button>
        <el-button
          v-show="leixing == 'change' || leixing == 'ck'"
          v-preventReClick
          style=""
          type="primary"
          @click="submitForm('form', 'bg')"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="cangchuSy_pupop">
    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        bgcs-t-k-name="仓储损溢"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'

import {
  url1,
  addccsyMes,
  editccsyMes,
  getccsyckMes,
  getccsywtdwMes,
  getkv,
  getccsyhxpMes,
  getToken,
  returnSaveFile,
  returnShowPic,
  changeccsyMes,
  changeYzccsyMes, addccsyMesTemp, editccsyMesTemp
} from '@/assets/js/common.js'
import { gethqdw } from '@/assets/js/ccgl.js'
// 获取经办人list
import { getgetLyrList } from '@/assets/js/ccgl'
import {isEmpty} from "@/utils/tool";
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: {
    ccsytype: {
      type: Boolean
    },
    leixing: {
      type: String
    },
    changeType: {
      type: Boolean
    },
    djsjshow: {
      type: Boolean
    },
    bgdisable: {
      type: Boolean
    }
    // dataMes: {
    //   type: Object,
    //   default: () => {},
    // },
  },
  data() {
    return {
      token: {
        Authorization: getToken()
      },
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 经办人list
      jbrList: [],
      dialogVisible2: false,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled2: false,
      form: {
        bblx: '', // 报备类型
        bblxStr: '', // 报备类型
        hxpMc: '', // 化学品
        hxpBm: '', // 化学品编码
        wtDwMc: '', // 委托单位id
        ckMc: '', // 仓库名称
        ckId: '', // 仓库id
        sysl: '', // 损溢数量
        syslDw: '', // 损溢数量单位
        syyy: '', // 损溢原因
        bbrq: '', // 报备日期
        djr: '', // 登记人
        djsj: '', // 登记时间
        bz: '', // 备注
        ztStr: '', // 状态中文
        zt: '', // 状态
        fj: '', // 证明材料
        dqkc: '',
        dqkcDw: '',
        // 新增1214@y
        jbrId: '',
        jbrName: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        bgly: ''
      },
      rules: {
        bblx: [{ required: true, message: '请选择', trigger: ['blur','change'] }],
        hxpBm: [{ required: true, message: '请选择', trigger: ['blur','change'] }],
        jbrName: [{ required: true, message: '请选择', trigger: ['blur','change'] }],
        wtDwMc: [{ required: true, message: '请选择', trigger: ['blur','change'] }],
        ckId: [{ required: true, message: '请选择', trigger: ['blur','change'] }],
        sysl: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.form.sysl) {
                return callback(new Error('请选择数量'))
              }
              if (!this.bgdisable && this.form.sysl < 0) {
                return callback(new Error('数量不能为负数'))
              }
              if (this.form.syslDw === this.form.dqkcDw) {
                if (this.form.bblx === 34 && this.form.sysl > this.form.dqkc) { return callback(new Error('损耗数量不能超过当前库存')) }
              }
              if (
                /^-?[1-9]\d{0,9}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) ==
                false
              ) {
                callback(new Error('整数位最大长度9位,保留3位小数'))
              }
              callback()
            },
            trigger: ['blur','change']
          }
        ],
        syslDw: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.form.syslDw) {
                return callback(new Error('请选择数量单位'))
              }
              // if (this.form.syslDw === this.form.dqkcDw) {
              //   if (this.form.bblx === 34 && this.form.sysl > this.form.dqkc)
              //     return callback(new Error("损耗数量不能超过当前库存"));
              // }
              callback()
            },
            trigger: ['blur','change']
          }
        ],
        syyy: [{ required: true, message: '请输入', trigger: ['blur','change'] }],
        bgly: [{ required: true, message: '请输入', trigger: ['blur','change'] }],
        bbrq: [{ required: true, message: '请选择', trigger: ['blur','change'] }],
        djsj: [{ required: true, message: '请选择', trigger: ['blur','change'] }]
      },
      options: [], // 数量单位
      options1: [], // 委托单位
      options2: [], // 仓库
      options3: [], // 获取化学品级联数据
      options4: [
        {
          label: '增溢',
          value: 35
        },
        {
          label: '损耗',
          value: 34
        }
      ],
      id: '',
      fileList: [],
      returnSaveFile: '', // 保存图片
      returnShowPic: '', // 回显图片
      URL1: '',
      syslList: [],
      biangengShow: false, // 变更理由显示
      keyValue: 1,

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },
  computed: {},
  watch: {
    options3(val, oldVal) {
      this.keyValue++
    },
    'fileList.length': {
      deep: true,
      handler(val, oldVal) {
        this.$nextTick(() => {
          if (this.leixing == 'ck' || this.leixing == 'change' || val == 1) {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    },

    'form.wtDwMc': {
      handler(val, oldVal) {
        if (this.form.wtDwMc) {
          if (this.options3.length == 0 || this.leixing != 'change') {
            getccsyhxpMes(val).then((e) => {
              this.options3 = e.data.data
            })
          }
        } else this.options3 = []
      },
      deep: true,
      immediate: true
    },
    'form.hxpBm': {
      handler(val, oldVal) {
        if (val) {
          if (typeof val === 'string' && val.constructor === String) {
            gethqdw(val).then((res) => {
              this.syslList = res.data.data
            })
          } else {
            gethqdw(val[val.length - 1]).then((res) => {
              this.syslList = res.data.data
            })
          }
        } else this.ckslList = []
        if (this.form.hxpBm && this.form.wtDwMc) {
          getccsyckMes(this.form.wtDwMc, val).then((e) => {
            this.options2 = e.data.data
            this.ckChange(this.form.ckId)
          })
        } else this.options2 = []
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    getkv('yzd_nsjsl_dw').then((e) => {
      this.options = e.data.data
    })
    getccsywtdwMes().then((e) => {
      this.options1 = e.data.data
    })

    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
  },
  mounted() {
    this.$nextTick(() => {})
    getgetLyrList().then((res) => {
      this.jbrList = res.data.data
    })
  },

  beforeDestroy() {},
  methods: {
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.$refs['form'].clearValidate()
    },
    // 经办人切换
    hchange(data) {
      this.jbrList.forEach((item) => {
        if (item.value == data) {
          this.form.jbrId = item.value
          this.form.jbrName = item.label
        }
      })
    },
    // @y1215
    handleRemovePic(file, fileList) {
      this.fileList = fileList
      if (!this.fileList) this.form.fj = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible2 = true
    },
    handleDownload(file) {},
    handlePreview(file) {},
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    handleAvatarSuccess(res, file) {
      this.form.fj = res.data.url
    },
    addccsyMess(dataObj) {
      addccsyMes(dataObj).then((e) => {
        this.$message({
          type: 'success',
          message: '提交成功!'
        })
        this.$parent.search()
        this.reset()
      })
    },
    editccsyMess(dataObj) {
      editccsyMes(dataObj).then((e) => {
        this.$message({
          type: 'success',
          message: '提交成功!'
        })
        this.$parent.search()
        this.reset()
      })
    },
    changeccsyMess(dataObj) {
      changeccsyMes(dataObj).then((e) => {
        this.$message({
          type: 'success',
          message: '变更成功!'
        })
        this.$parent.search()
        this.reset()
      })
    },
    changeYzccsyMess(dataObj) {
      changeYzccsyMes(dataObj).then((e) => {
        if (e.data.data.type == 'success') this.changeccsyMess(dataObj)
        else {
          this.$confirm(e.data.data.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          })
            .then(() => {
              this.changeccsyMess(dataObj)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      })
    },
    wtdwChange(value) {
      if (this.leixing != 'change') {
        this.form.hxpMc = ''
        this.form.hxpBm = ''
      }
      this.form.ckMc = ''
      this.form.ckId = ''
      this.form.dqkc = ''
      this.form.dqkcDw = ''
    },
    // 化学品级联改变
    handleChange(value) {
      this.form.ckMc = ''
      this.form.ckId = ''
      this.form.dqkc = ''
      this.form.dqkcDw = ''
      if (value == undefined) return
      // this.form.hxpBm = value.slice(1).toString();
      // 化学品编码
      this.form.hxpBm = value[value.length - 1]
      this.options3.forEach((item) => {
        if (item.value == value.slice(0, 1).toString()) {
          item.children.forEach((itemChidren) => {
            if (itemChidren.value == this.form.hxpBm);
          })
        }
      })
    },
    // 仓库改变
    ckChange(val) {
      this.form.ckMc = ''
      this.form.dqkc = ''
      this.form.dqkcDw = ''
      this.form.ckId = val
      this.options2.forEach((item) => {
        if (item.value == val) {
          this.form.ckMc = item.label
          this.form.dqkc = item.kcl
          this.form.dqkcDw = item.kclDw
          // @y新增5个字段
          this.form.hxpMc = item.label
          this.form.bgyId = item.ckbgyId
          this.form.bgyxm = item.ckbgy
          this.form.bgydh = item.ckbgyDh
        }
      })
    },
    bblxChange(val) {
      this.form.bblx = val
      this.options4.forEach((item) => {
        if (item.value == val) {
          this.form.bblxStr = item.label
        }
      })
    },

    reset() {
      this.form = this.$options.data().form
      this.syslList = []
      this.fileList = []
      setTimeout(() => {
        this.$refs['form'].clearValidate()
      }, 30)
      this.dialogVisible = false
    },
    getformMes(dataMes, type) {
      this.id = type == 'edit' || type == 'change' ? dataMes.id : '' // 根据id来知道编辑的数据
      this.form = Object.assign(
        {},
        {
          bblx: dataMes.bblx, // 报备类型
          bblxStr: dataMes.bblxStr, // 报备类型
          hxpMc: dataMes.hxpMc, // 化学品
          hxpBm: dataMes.hxpBm, // 化学品编码
          wtDwMc: dataMes.wtDwMc, // 委托单位id
          ckMc: dataMes.ckMc, // 仓库名称
          ckId: dataMes.ckId, // 仓库id
          sysl: dataMes.sysl, // 损溢数量
          syslDw: isEmpty(dataMes.hxpBm)?'':dataMes.syslDw, // 损溢数量单位
          syyy: dataMes.syyy, // 损溢原因
          bbrq: dataMes.bbrq, // 报备日期
          djr: dataMes.djr, // 登记人
          djsj: dataMes.djsj, // 登记时间
          bz: dataMes.bz, // 备注
          ztStr: dataMes.ztStr, // 状态中文
          zt: dataMes.zt, // 状态
          fj: dataMes.fj,
          dqkc: dataMes.dqkc,
          dqkcDw: dataMes.dqkcDw,
          // 新增5@y
          jbrId: dataMes.jbrId, // 经办人id
          jbrName: dataMes.jbrName, // 经办人
          bgyId: dataMes.bgyId, // 保管员id
          bgyxm: dataMes.bgyxm, // 保管员姓名
          bgydh: dataMes.bgydh // 保管员电话
        }
      )
      this.$nextTick(() => {
        if (this.leixing == 'ck' || this.leixing == 'change') {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'none'
        } else {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'inline-block'
        }
      })

      if (this.form.fj) {
        this.fileList = [
          {
            url: this.returnShowPic + this.form.fj
          }
        ]
      }
    },
    // 提交表单内容（暂时保存）
    submitFormTemp() {
      if (this.ccsytype == true) {
        this.reset()
        return
      }
      // 编辑和复制新增需要验证
      this.zt = '00'
      var data = {
        id: this.id,
        bblx: this.form.bblx, // 报备类型
        bblxStr: this.form.bblxStr, // 报备类型
        hxpMc: this.form.hxpMc, // 化学品
        hxpBm: this.form.hxpBm, // 化学品编码
        wtDwMc: this.form.wtDwMc, // 委托单位id
        ckMc: this.form.ckMc, // 仓库名称
        ckId: this.form.ckId, // 仓库id
        sysl: this.form.sysl, // 损溢数量
        syslDw: this.form.syslDw, // 损溢数量单位
        syyy: this.form.syyy, // 损溢原因
        bbrq: this.form.bbrq, // 报备日期
        bz: this.form.bz, // 备注
        djr: this.form.djr,
        ztStr: this.form.ztStr, // 状态中文
        zt: this.zt, // 状态
        fj: this.form.fj, // 附件地址
        jbrId: this.form.jbrId, // 经办人id
        jbrName: this.form.jbrName, // 经办人
        bgyId: this.form.bgyId, // 保管员id
        bgyxm: this.form.bgyxm, // 保管员姓名
        bgydh: this.form.bgydh, // 保管员电话
        bgly: this.form.bgly // 保管员电话
      }
      this.$confirm('此操作将暂时保存该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
          .then(() => {
            this.leixing == 'add'
                ? (
                    addccsyMesTemp(data).then((e) => {
                      this.$message({
                        type: 'success',
                        message: '保存成功!'
                      })
                      this.$parent.search()
                      this.reset()
                    })
                )
                :
                (
                    editccsyMesTemp(data).then((e) => {
                      this.$message({
                        type: 'success',
                        message: '保存成功!'
                      })
                      this.$parent.search()
                      this.reset()
                    })
                )
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
    },
    // 提交表单内容（提交保存）
    submitForm(formName, type) {
      if (this.ccsytype == true) {
        this.reset()
        return
      }
      // 编辑和复制新增需要验证
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          if (!this.form.fj) {
            this.$message.error('请上传附件')
            return false
          }
          this.zt = type == 'zsbc' ? '00' : '01'
          var data = {
            id: this.id,
            bblx: this.form.bblx, // 报备类型
            bblxStr: this.form.bblxStr, // 报备类型
            hxpMc: this.form.hxpMc, // 化学品
            hxpBm: this.form.hxpBm, // 化学品编码
            wtDwMc: this.form.wtDwMc, // 委托单位id
            ckMc: this.form.ckMc, // 仓库名称
            ckId: this.form.ckId, // 仓库id
            sysl: this.form.sysl, // 损溢数量
            syslDw: this.form.syslDw, // 损溢数量单位
            syyy: this.form.syyy, // 损溢原因
            bbrq: this.form.bbrq, // 报备日期
            bz: this.form.bz, // 备注
            djr: this.form.djr,
            ztStr: this.form.ztStr, // 状态中文
            zt: this.zt, // 状态
            fj: this.form.fj, // 附件地址
            jbrId: this.form.jbrId, // 经办人id
            jbrName: this.form.jbrName, // 经办人
            bgyId: this.form.bgyId, // 保管员id
            bgyxm: this.form.bgyxm, // 保管员姓名
            bgydh: this.form.bgydh, // 保管员电话
            bgly: this.form.bgly // 保管员电话
          }
          if (type == 'tj') {
            this.$confirm('此操作将保存该数据，不可撤回, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                this.leixing == 'add'
                  ? this.addccsyMess(data)
                  : this.editccsyMess(data)
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          } else if (type == 'zsbc') {
            this.$confirm('此操作将暂时保存该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                this.leixing == 'add'
                  ? this.addccsyMess(data)
                  : this.editccsyMess(data)
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          } else if (type == 'bg') {
            this.changeYzccsyMess(data)
          } else {
            this.reset()
          }
        } else {
          return false
        }
      })
    },
    close() {
      this.reset()
    }
  }
}
</script>
<style scoped lang="less">
.cangchuSy_pupop {
  .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      width: 45%;
    }
  }
  .buttonList {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    .el-button:nth-child(1) {
      margin-right: 190px;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
    .el-button:nth-child(2),
    .el-button:nth-child(3) {
      background-color: #4170ff;
      color: white;
      width: 148px;
      height: 60px;
      border: none;
    }
  }
}
/deep/.avatar-uploader .el-upload {
  border: 0 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader {
  height: 96px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
  text-align: center;
  background: #f3f3f3;
  border-radius: 3px;
}
/deep/.el-upload {
  line-height: 96px !important;
}
.avatar {
  display: block;
}
/deep/.el-upload-list--picture-card .el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
}
</style>
